const _getIsApprovalForRevisionRequested = (revision) => {
  return revision.approval && revision.approvalStatus !== 'notrequested'
}

export default _getIsApprovalForRevisionRequested
